var React = require('react');

function CompanyHeroFlag2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m-116.625546 171.519948 934.658368-539.62526 101.497583 591.510283-754.650089 435.697432z","fill":"#eaf4f3","fillRule":"evenodd","transform":"matrix(-.8660254 .5 .5 .8660254 858.9663 -181.898075)"}));
}

CompanyHeroFlag2.defaultProps = {"preserveAspectRatio":"none","height":"472","viewBox":"0 0 985 472","width":"985"};

module.exports = CompanyHeroFlag2;

CompanyHeroFlag2.default = CompanyHeroFlag2;
